// extracted by mini-css-extract-plugin
export var contentBody = "_6n-9";
export var headerImage = "_6n-2";
export var imageButton = "_6n-7";
export var imageButtonIcon = "_6n-8";
export var imageHeader = "_6n-4";
export var imageHeaderText = "_6n-5";
export var imageOverlay = "_6n-3";
export var imageTitle = "_6n-6";
export var imageWrapper = "_6n-1";
export var taskList = "_6n-a";
export var widget = "_6n-0";